/**
 * Generic modal
 * @method setAlertModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    //authen
    this.pdpaModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;
    this.shareModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddressModal = null;
    this.editTaxAddressModal = null;
    this.listTaxAddressModal = null;
    //pdpa
    this.cancelTermsAndPrivacyModal = null
    // profile
    this.changeMobileNumberModal = null;
    this.flashSaleModal = null;
    // badge
    this.badgeAlertModal = null;
    //surprisebox
    this.confirmSurpriseModal = null;
    this.alertConditionModal = null;

    this.fgfModal = null;
    this.shareModal = null;

    this.promocodeModal = null;

    this.verifyCodeModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    //#endregion generic

    //#region authen
    this.setPdpaModal = function (pdpaModalController) {
        this.pdpaModal = pdpaModalController;
    };
    //#endregion authen

    //#region redeem
    this.setConfirmRedeemModal = function (confirmRedeemModalController) {
        this.confirmRedeemModal = confirmRedeemModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setDrawDeliveryModal = function (drawDeliveryModalController) {
        this.drawDeliveryModal = drawDeliveryModalController;
    };
    this.setShippingAddressModal = function (shippingAddressModalController) {
        this.shippingAddressModal = shippingAddressModalController;
    };
    this.setShareModal = function (shareModalController) {
        this.shareModal = shareModalController;
    };
    //#endregion redeem

    //#region address
    this.setAddAddressModal = function (addAddressModalController) {
        this.addAddressModal = addAddressModalController;
    };
    this.setEditAddressModal = function (editAddressModalController) {
        this.editAddressModal = editAddressModalController;
    };
    this.setListAddressModal = function (listAddressModalController) {
        this.listAddressModal = listAddressModalController;
    };
    this.setAddTaxAddressModal = function (addTaxAddressModalController) {
        this.addTaxAddressModal = addTaxAddressModalController;
    };
    this.setEditTaxAddressModal = function (editTaxAddressModalController) {
        this.editTaxAddressModal = editTaxAddressModalController;
    };
    this.setListTaxAddressModal = function (listTaxAddressModalController) {
        this.listTaxAddressModal = listTaxAddressModalController;
    };
    //#endregion address

    //#region pdpa
    this.setCancelTermsAndPrivacyModal = function (CancelTermsAndPrivacyModalController) {
        this.cancelTermsAndPrivacyModal = CancelTermsAndPrivacyModalController;
    };
    //#endregion pdpa
    //#region profile
    this.setChangeMobileNumberModal = function (ChangeMobileNumberModalController) {
        this.changeMobileNumberModal = ChangeMobileNumberModalController;
    }
    //#endregion profile
    this.setFlashSaleModal = function(FlashsaleModalController) {
        this.flashSaleModal = FlashsaleModalController;
    };
    this.setBadgeAlertModal = function(badgeAlertModalController) {
        this.badgeAlertModal = badgeAlertModalController;
    };
    //surprisebox
    this.setConfirmSurpriseModal = function(ConfirmSurpriseModalController) {
        this.confirmSurpriseModal = ConfirmSurpriseModalController;
    };
    this.setAlertConditionModal = function(AlertConditionModalController) {
        this.alertConditionModal = AlertConditionModalController;
    };

    this.setFGFModal = function (FGFModalController) {
        this.fgfModal = FGFModalController;
    };

    this.setShareFGFModal = function (FGFShareModalController) {
        this.sharefgfModal = FGFShareModalController;
    }

    this.setPromocodeModal = function (PromocodeModalController) {
        this.promocodeModal = PromocodeModalController;
    }

    this.setPromocodeSuccessModal = function (PromocodeSuccessModalController) {
        this.promocodeSuccessModal = PromocodeSuccessModalController;
    }

    this.setVerifyCodeModal = function (VerifyCodeModalController) {
        this.verifyCodeModal = VerifyCodeModalController;
    }
}
